import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppStore } from './store';
import {
  gameFinished,
  gameInProgress,
  gameNotStarted,
  gameWillStart,
  IGameState,
  isGameInProgress,
  isStartGame,
} from '../constants/game-state';
import { IGameOptions } from '../types/game-options';
import { MapsTemp } from '../game-engine/maps-utils/map-functions-temp';
import { link_comp } from '../game-engine/maps-utils/constants';
import audioBigApple from '../game/FirstTrack.mp3';
import audioStacksPlaza from '../game/SecondTrack.mp3';
import audioDegenRaceway from '../game/ThirdTrack.mp3';
import audioMiamiBeach from '../game/FourthTrack.mp3';
import { audio } from '../components/PlayGame';
import { playSong, pauseSong } from '../game/commandsSong';

import { MapOrderById } from '../game-engine/maps-utils/map-order';
import $ from 'jquery';

export interface GameEngineStore {
  lapTimes: Record<MapsTemp, number | null>;
  hasStarted: IGameState;
}

const initialState: GameEngineStore = {
  lapTimes: {
    bigApple: null,
    stackPlaza: null,
    degenRaceway: null,
    miamiBeach: null,
  },
  hasStarted: gameNotStarted(),
};

export interface IEndRaceGameProps {
  currentMapId: MapsTemp;
  lapTime: number;
  nextGameOptions: IGameOptions;
  idLobby: number | null;
}

function colorHud(hud: HTMLElement, color: string) {
  hud.style.backgroundColor = color;
}

function setHudForGivenMap(hud: HTMLElement, mapName: string) {
  hud.style.borderBottom = '2px solid #000';
  switch (mapName) {
    case 'bigApple':
      colorHud(hud, 'rgba(45, 167, 166, 0.7)');
      console.log('it is big apppls hud');
      break;
    case 'stackPlaza':
      colorHud(hud, 'rgba(0, 2, 65, 0.7)');
      break;
    case 'degenRaceway':
      colorHud(hud, 'rgba(126, 204, 186, 0.7)');
      break;
    case 'miamiBeach':
      colorHud(hud, 'rgba(37, 32, 89, 0.7)');
      break;
    default:
      colorHud(hud, 'rgba(0, 0, 0, 0)');
      break;
  }
}

function playSongForGivenMap(audio: HTMLAudioElement, mapName: string) {
  switch (mapName) {
    case 'bigApple':
      playSong(audio, audioBigApple);
      break;
    case 'stackPlaza':
      playSong(audio, audioStacksPlaza);
      break;
    case 'degenRaceway':
      playSong(audio, audioDegenRaceway);
      break;
    case 'miamiBeach':
      playSong(audio, audioMiamiBeach);
      break;
    default:
      break;
  }
}

function pauseSongForGivenMap(audio: HTMLAudioElement, mapName: string) {
  switch (mapName) {
    case 'bigApple':
      pauseSong(audio, audioBigApple);
      break;
    case 'stackPlaza':
      pauseSong(audio, audioStacksPlaza);
      break;
    case 'degenRaceway':
      pauseSong(audio, audioDegenRaceway);
      break;
    case 'miamiBeach':
      pauseSong(audio, audioMiamiBeach);
      break;
    default:
      break;
  }
}

export const Slice = createSlice({
  name: 'game_engine',
  initialState,
  reducers: {
    prepareRaceGame: (state: GameEngineStore, action: PayloadAction<IGameOptions>) => {
      // overlaps with the toggle button music
      // only adds it when loading first map
      // if ((MapOrderById as any)[action.payload.id] == 0)
      //   document.addEventListener('keydown', function (e) {
      //     if (e.keyCode == 77) {
      //       // toogleMusic();
      //       if (localStorage.getItem('isPlayingMusic') == 'false') {
      //         localStorage.setItem('isPlayingMusic', 'true');
      //         audio.play();
      //       } else {
      //         localStorage.setItem('isPlayingMusic', 'false');
      //         audio.pause();
      //       }
      //     }
      //   });
      const mapName = action.payload.id;
      const hud = document.getElementById('hud');
      if (hud !== null) {
        setHudForGivenMap(hud, mapName);
      }

      // overlaps with the toggle button music
      // if (localStorage.getItem('isPlayingMusic') == 'true') {
      //   playSongForGivenMap(audio, mapName);
      // } else {
      //   pauseSongForGivenMap(audio, mapName);
      // }

      return { ...state, hasStarted: gameWillStart(action.payload) };
    },
    startRaceGame: (state: GameEngineStore, action: PayloadAction<IGameOptions>) => {
      return { ...state, hasStarted: gameInProgress(action.payload) };
    },
    crossStartLine: (state: GameEngineStore, action: PayloadAction<IGameOptions>) => {
      // console.log(new Date());
      // console.log(action.payload.currentMapId);
      // $.post(link_comp + '/new_start', {
      //   //idLobbyIn: ,
      //   addressIn: JSON.parse(localStorage.getItem('userData') as any),
      //   mapIn: (MapOrderById as any)[action.payload.currentMapId] + 1,
      //   nrNFTIn: localStorage.getItem('nrNFT'),
      // });
      return state;
    },
    endRaceGame: (state: GameEngineStore, action: PayloadAction<IEndRaceGameProps>) => {
      const { nextGameOptions, currentMapId, lapTime, idLobby } = action.payload;
      const updatedLapTimes = { ...state.lapTimes, [currentMapId]: lapTime };
      if (idLobby == -1) {
        // is a grand prix race
        //getaddress and nft from redux probs useSelector
        $.post(link_comp + '/new-score-grand-prix', {
          idLobby: idLobby,
          address: JSON.parse(localStorage.getItem('userData') as any),
          nft: localStorage.getItem('nrNFT'),
          score: lapTime.toFixed(4),
        });
      } else if (idLobby) {
        // is a lobby race
        //getaddress and nft from redux probs useSelector
        $.post(link_comp + '/new-score', {
          idLobby: idLobby === null ? 0 : idLobby,
          address: JSON.parse(localStorage.getItem('userData') as any),
          nft: localStorage.getItem('nrNFT'),
          score: lapTime.toFixed(4),
        });
      } else {
        // plays story mode
        $.post(link_comp + '/story-new-score', {
          idLobby: idLobby === null ? 0 : idLobby,
          address: JSON.parse(localStorage.getItem('userData') as any),
          mapIn: MapOrderById[currentMapId] + 1,
          nft: localStorage.getItem('nrNFT'),
          score: lapTime.toFixed(4),
        });
        // finished story mode maps
        console.log('mapOrder', MapOrderById[currentMapId] + 1);
        if (MapOrderById[currentMapId] + 1 === 4) {
          $.post(link_comp + '/story-new-complete', {
            address: JSON.parse(localStorage.getItem('userData') as any),
            nft: localStorage.getItem('nrNFT'),
            scoreIn4: lapTime.toFixed(4),
          });
        }
      }
      return { ...state, lapTimes: updatedLapTimes, hasStarted: gameFinished(currentMapId, nextGameOptions, idLobby) };
    },
    resetGame: (state) => {
      return initialState;
    },
  },
});

export const selectGameEngineStore = (state: AppStore) => state.gameStore;
export const selectHasRaceStarted = createSelector(selectGameEngineStore, (state: GameEngineStore) => state.hasStarted);
export const selectRaceTimes = createSelector(selectGameEngineStore, (state) => state.lapTimes);

export const { prepareRaceGame, startRaceGame, endRaceGame, resetGame, crossStartLine } = Slice.actions;
export default Slice.reducer;
